/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { ChipStatus, DialogForm, IChipsSettingProps, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { IntegrationDTO, IntegrationSettingDTO, UserDTO, ValueListDTO } from '../../../shared/interfaces';
import { dateDiff, formatDateTime } from '../../../shared/utils';

interface IIntegrationMaintenanceProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const IntegrationMaintenance: React.FC<IIntegrationMaintenanceProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [integrationSettingList, setIntegrationSettingList] = useState<IntegrationSettingDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [userList, setUserList] = useState<UserDTO[]>([]);

    const [integrationDTO, setIntegrationDTO] = useState<IntegrationDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setIntegrationDTO({
            ...integrationDTO,
            id: '',
            integrationSettingId: '',
            sourceId: '',
            startDateTime: undefined,
            endDateTime: undefined,
            statusId: ''//ListId.linksphere.integration.startStatusId,
        } as IntegrationDTO);

        if(isOpenMaintenance){
            handleListGetAll(ListId.linksphere.integration.statusId, setStatusList);
            handleUserGetAllAsync();
            handleIntegrationSettingGetAll();
            handleGetIntegrationByIdAsync();
        }
    }, [data, isOpenMaintenance]);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'value ASC'
        };
        GenericService.GetAllAsync1('parmsphere.valueList', valueListFilterDTO, setLoading, setList, showMessage);
    }, []);

    const handleIntegrationSettingGetAll = useCallback(async () => {
        const integrationSettingFilterDTO = {

        };
        GenericService.GetAllAsync1('linksphere.integrationSetting', integrationSettingFilterDTO, setLoading, setIntegrationSettingList, showMessage);
    }, []);

    const handleUserGetAllAsync = useCallback(async () => {
        const userFilterDTO = {
            integrationId: userInfo.user.integrationId,
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);

    }, []);

    const handleGetIntegrationByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('linksphere.integration', data.id, setLoading, setIntegrationDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = integrationDTO as IntegrationDTO;

        if (integrationDTO?.id === '' || integrationDTO?.id === undefined) {
            dto.statusId = ListId.linksphere.integration.startStatusId;
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('linksphere.integration', dto, setIntegrationDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('linksphere.integration', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [integrationDTO]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const chipStatus : IChipsSettingProps[] = [
        { value: 'Waiting for processing', iconName: 'timer_outlined', iconColor: 'primary' },
        { value: 'Processing', iconName: 'update_outlined', iconColor: 'info' },
        { value: 'Successfully integrated', iconName: 'done_all_outlined', iconColor: 'success' },
        { value: 'Integration failed', iconName: 'running_with_errors_outlined', iconColor: 'error' },
        { value: 'Reprocessing Integration', iconName: 'manage_history_outlined', iconColor: 'warning' }
    ];

    const actions: IDialogActions[] = [
        { id: 'save', text: 'Save', icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick },
        { id: 'cancel', text: 'Cancel', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title='INTEGARTION DETAILS'
                icon='grid_view_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <SelectField
                                id='integrationSettingId'
                                label='Integration Setting'
                                placeholder='Integration Setting'
                                value={integrationDTO?.integrationSettingId}
                                setValue={setIntegrationDTO}
                                obj={integrationDTO}
                                valueList={integrationSettingList}
                                required={true}
                                hasNoneSelect={false}
                                disabled={integrationDTO?.id ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextFieldInput
                                id='integrationSettingId'
                                label='Integration Setting Id'
                                value={integrationDTO?.integrationSettingId}
                                setValue={setIntegrationDTO}
                                obj={integrationDTO}
                                required={true}
                                maxLength={36}
                                disabled={integrationDTO?.id ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextFieldInput
                                id='sourceId'
                                label='Source Id'
                                value={integrationDTO?.sourceId}
                                setValue={setIntegrationDTO}
                                obj={integrationDTO}
                                required={true}
                                maxLength={36}
                                disabled={integrationDTO?.id ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextFieldReadOnly
                                id={'statusId'}
                                label='Status'
                                value={(<ChipStatus label='Status' value={String(statusList.find(x => x.id === integrationDTO?.statusId)?.value || 'New Integration')} chipSettings={chipStatus} />)}
                                hasDivider={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextFieldReadOnly
                                id={'startDateTime'}
                                label='Start Date Time'
                                value={formatDateTime(String(integrationDTO?.startDateTime))}
                                hasDivider={false}
                                hasToolTip={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextFieldReadOnly
                                id={'endDateTime'}
                                label='End Date Time'
                                value={formatDateTime(String(integrationDTO?.endDateTime))}
                                hasDivider={false}
                                hasToolTip={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextFieldReadOnly
                                id={'Elapsed Time'}
                                label='Elapsed Time'
                                value={integrationDTO?.startDateTime ? dateDiff(String(integrationDTO.startDateTime), String(integrationDTO.endDateTime)) : undefined}
                            />
                        </Grid>
                        {integrationDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label='Id'
                                        value={integrationDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label='Created By'
                                        value={userList.find(x => x.id === integrationDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label='Creation Date'
                                        value={formatDateTime(String(integrationDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label='Updated By'
                                        value={userList.find(x => x.id === integrationDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label='Update Date'
                                        value={formatDateTime(String(integrationDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};